import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/MainLayout';
import './RoleRegistrationPage.css';

function RoleRegistrationPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    roleName: '',
    roleCode: '',
    description: '',
    status: '활성',
    permissions: {
      dashboard: false,
      monitoring: false,
      factory: false,
      equipment: false,
      user: false,
      system: false
    }
  });

  const permissionLabels = {
    dashboard: '대시보드',
    monitoring: '모니터링',
    factory: '공장관리',
    equipment: '설비관리',
    user: '회원관리',
    system: '시스템관리'
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePermissionChange = (permission) => {
    setFormData(prev => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [permission]: !prev.permissions[permission]
      }
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 유효성 검사
    if (!formData.roleName.trim()) {
      alert('권한명을 입력해주세요.');
      return;
    }
    if (!formData.roleCode.trim()) {
      alert('권한코드를 입력해주세요.');
      return;
    }

    try {
      // TODO: 권한 등록 API 호출
      // await createRole(formData);
      
      alert('권한이 등록되었습니다.');
      navigate('/role-management');
    } catch (error) {
      console.error('권한 등록 실패:', error);
      alert('권한 등록에 실패했습니다.');
    }
  };

  const handleCancel = () => {
    if (window.confirm('작성 중인 내용이 저장되지 않습니다. 취소하시겠습니까?')) {
      navigate('/role-management');
    }
  };

  return (
    <MainLayout>
      <div className="role-registration-container">
        {/* Header Section */}
        <div className="role-registration-header">
          <div className="role-registration-header-left">
            <div className="role-registration-title">권한 등록</div>
            <p className="role-registration-subtitle">새로운 권한 정보를 등록합니다</p>
          </div>
        </div>

        {/* Form Section */}
        <div className="role-registration-content">
          <form onSubmit={handleSubmit}>
            {/* 기본 정보 섹션 */}
            <div className="form-section">
              <h3 className="section-title">기본 정보</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label className="form-label">
                    권한명 <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="roleName"
                    value={formData.roleName}
                    onChange={handleInputChange}
                    placeholder="권한명을 입력하세요"
                    className="form-input"
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">
                    권한코드 <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="roleCode"
                    value={formData.roleCode}
                    onChange={handleInputChange}
                    placeholder="예: ADMIN, MANAGER"
                    className="form-input"
                    required
                  />
                </div>
                <div className="form-group full-width">
                  <label className="form-label">설명</label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    placeholder="권한에 대한 설명을 입력하세요"
                    className="form-textarea"
                    rows="3"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">상태</label>
                  <div className="dropdown-container">
                    <select
                      name="status"
                      value={formData.status}
                      onChange={handleInputChange}
                      className="form-select"
                    >
                      <option value="활성">활성</option>
                      <option value="비활성">비활성</option>
                    </select>
                    <svg className="dropdown-icon" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M2 4L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            {/* 권한 설정 섹션 */}
            <div className="form-section">
              <h3 className="section-title">권한 설정</h3>
              <div className="permissions-container">
                {Object.entries(permissionLabels).map(([key, label]) => (
                  <label key={key} className="permission-checkbox">
                    <input
                      type="checkbox"
                      checked={formData.permissions[key]}
                      onChange={() => handlePermissionChange(key)}
                    />
                    <span className="checkbox-custom"></span>
                    <span className="permission-label">{label}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Form Actions */}
            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={handleCancel}>
                취소
              </button>
              <button type="submit" className="btn-primary">
                권한 등록
              </button>
            </div>
          </form>
        </div>
      </div>
    </MainLayout>
  );
}

export default RoleRegistrationPage;
